module.exports = __webpack_public_path__ + "static/media/FinnoSec Africa-Design Updates.4f57f604.docx";